import { CongratulationsIcon } from '@assets/congratulations';
import { AuthHeader } from '@features/auth/AuthHeader';
import { AuthPepper } from '@features/AuthPaper';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

export const CongratulationsForm = () => {
	const { navigateWithLanguage } = useLanguageNavigate();
	const { t } = useTranslation();

	const handleConfirmationClick = () => {
		navigateWithLanguage('/login');
	};

	return (
		<AuthPepper className="bg-[#FFF8F4]">
			<div className="max-w-xxl w-[330px] sm:!w-[448px]">
				<AuthHeader wrapperSpacing="mb-[45px] max-sm:mb-[132px]" />
				<div className="max-w-custom-448 mt-[45px] mx-auto flex flex-col gap-[45px]">
					<div className="flex justify-center items-center gap-[35px]">
						<CongratulationsIcon />
						<div>
							<h4 className="roboto-bold text-primary text-[30px] mb-[20px]">
								{t('congratulations')}!
							</h4>
							<p className="roboto-regular text-secondary">{t('successMessage')}</p>
						</div>
					</div>
					<Button
						onClick={handleConfirmationClick}
						type="submit"
						color="primary"
						variant="contained"
						fullWidth
						sx={{ font: 'roboto-bold', fontSize: '14px' }}
					>
						{t('login')}
					</Button>
				</div>
			</div>
		</AuthPepper>
	);
};
